//prefix time adder
export const timePrefix = time => {
    let t = (time < 10) ? "0".concat(time) : time;
    return t;
};

//Add days function
export const addDays = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};

export const addElements = (arr, element) => {
    if(arr.length >= 0){
        if(arr.indexOf(element) === -1){
            arr.push(element);
        }
    }

    return arr;
}

export const daysOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const monthNamesFI = ["Tammikuu", "Helmikuu", "Maaliskuu", "Huhtikuu", "Toukokuu", "Kesäkuu", "Heinäkuu", "Elokuu", "Syyskuu", "Lokakuu", "Marraskuu", "Joulukuu"];

export const monthNamesAR = new Array("Muharram","Safar","Rabi'ul Awwal","Rabi'ul Akhir",
	"Jumadal Ula","Jumadal Akhira","Rajab","Sha'ban",
    "Ramadan","Shawwal","Dhul Qa'ada","Dhul Hijja");
    
export const daysInMonth = (month, year) => { 
    return new Date(year, month, 0).getDate();
} 